export const VoucherCreateSceneTranslation = {
  fi: {
    VoucherCreateScene: {
      title: 'Luo uusi kuponki',
      save: 'Luo',
      back: 'Takaisin',
    },
  },
};
